export async function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onerror = reject
    img.src = src
    if (img.complete) {
      console.log('complete')
      resolve(img)
    } else {
      img.addEventListener('load', () => resolve(img))
    }
  })
}
